import './EledoToggleButton.scss';
import classnames from "classnames";
import PropTypes from "prop-types";
import {useState} from "react";

const EledoToggleButton = ({ id, leftLabel, rightLabel, iconified = false,
                             size = 'default',
                             value, defaultValue, onChangeHandler: onChange = () => {},
                             style = {}, children, ...props}) => {

  const [_checked, _setChecked] = useState(defaultValue);

  const _handleChange = () => {
    if(!props.disabled) {
      _setChecked(!_checked);
      onChange(!_checked);
    }
  };

  return (
    <div className={classnames("toggle-button", "rounded", size, iconified ? 'iconified' : '')}
         style={{...style, overflow: "visible"}}>
      <input id={id}
             {...props}
             type="checkbox"
             className="checkbox"
             name={id}
             value={_checked}
             onClick={e => {e.stopPropagation(); _handleChange();}}/>
      <div className="knobs" data-unchecked={leftLabel} data-checked={rightLabel}/>
      <div className="layer"/>
      {children}
    </div>
  );
};

EledoToggleButton.propTypes = {
  id: PropTypes.string.isRequired,
  leftLabel: PropTypes.any,
  rightLabel: PropTypes.any,
  size: PropTypes.oneOf(['default', 'large', 'small']),
  iconified: PropTypes.bool,
  value: PropTypes.bool,
  defaultValue: PropTypes.bool,
  onChangeHandler: PropTypes.func
}

export default EledoToggleButton;